
/*
  Sticky ATC
*/
const initStickyAtc = async () => {
  const wrapper = document.querySelector('#sticky-atc')

  if (!wrapper) return

  await new Promise(resolve => setTimeout(resolve, 1000))

  const form = document.querySelector('.product-content form[action*="/cart/add"], form[action*="/cart/add"], form.shopify-product-form, form[onsubmit*="onSubmitAtcForm"]')
  if (!form) return

  let threshold = form.getBoundingClientRect().bottom + window.scrollY

  const onScroll = () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add('show')
      document.body.style.paddingBottom = wrapper.clientHeight + 'px'
    } else {
      wrapper.classList.remove('show')
      document.body.style.paddingBottom = 0
    }
  }

  window.addEventListener('scroll', onScroll)
  window.addEventListener('resize', () => {
    threshold = form.getBoundingClientRect().bottom + window.scrollY
    onScroll()
  })

  onScroll()
}
initStickyAtc()